import { Draggable } from "react-beautiful-dnd";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";

interface FabricItem {
  id: string;
  image: { src: string };
  code: string;
  color_name: string;
}

interface Props {
  fabric: FabricItem;
  index: number;
  control: Control<any>;
  setValue: any;
}

export function DraggableFabricItem({
  fabric,
  index,
  control,
  setValue,
}: Props) {
  const handleDelete = () => {
    setValue("fabrics", (prev: any[]) => {
      const newFabrics = prev.filter((_, i) => i !== index);
      // Update order for remaining items
      return newFabrics.map((fabric, i) => ({
        ...fabric,
        order: i,
      }));
    });
  };

  return (
    <Draggable draggableId={fabric.id} index={index} key={fabric.id}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="flex items-center space-x-4 p-2 border rounded-lg mt-2 bg-white"
        >
          <FormField
            control={control}
            name={`fabrics.${index}.image.src`}
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <img
                    src={field.value || ""}
                    alt="Fabric Image"
                    style={{ width: "80px", height: "80px" }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name={`fabrics.${index}.code`}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Fabric Code</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Fabric Code"
                    type="text"
                    {...field}
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={control}
            name={`fabrics.${index}.color_name`}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Fabric Color</FormLabel>
                <FormControl>
                  <Input
                    placeholder="Fabric Color"
                    type="text"
                    {...field}
                    value={field.value || ""}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDelete}
            className="ml-auto text-red-500 hover:text-red-700 hover:bg-red-100"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      )}
    </Draggable>
  );
}
